import { render, staticRenderFns } from "./pertamaMobile.vue?vue&type=template&id=e8fe3fe6&scoped=true&"
import script from "./pertamaMobile.vue?vue&type=script&lang=js&"
export * from "./pertamaMobile.vue?vue&type=script&lang=js&"
import style0 from "./pertamaMobile.vue?vue&type=style&index=0&id=e8fe3fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fe3fe6",
  null
  
)

export default component.exports